export default __webpack_public_path__ + "static/media/jebel-ali-free-zone.725b5757.png";